import React, { useState } from 'react'

import { Grid } from '@mui/material'
import { toast } from 'react-toastify'

import { Buttons } from "../../reusableUI/Buttons"
import { InputsNumbers } from "../../reusableUI/InputsNumbers"
import { Selects } from '../../reusableUI/Selects'

import { Settings } from '../../../models/settings'

const typeList = [
    { id: 1, cod: 'general', nombre: 'General' },
    { id: 2, cod: 'unidad', nombre: 'Por unidad de negocio' }
]

const initialState = {
    id: 0,
    id_tipo_regla: '',
    id_unidad_negocio: '',
    rentabilidad_esperada: '',
    habilitado: true
}

export const NewRule = ({ getRulesList, unitList }) => {

    const [form, setForm] = useState(initialState)

    const handleChange = ({ target }) => {
        console.log(target.name, target.value)
        setForm({
            ...form,
            [target.name]: target.value
        })
    }

    const handleSubmitNewUser = async (e) => {
        e.preventDefault()
        //console.log(form)

        if (!form.id_tipo_regla || form.id_tipo_regla === '' || parseInt(form.id_tipo_regla) === 0) {
            toast.warn("Falta seleccionar tipo de regla")
            return false
        }

        if (form.id_tipo_regla === 2 && form.id_unidad_negocio === '') {
            toast.warn("Falta seleccionar unidad de negocio")
            return false
        }

        if (!form.rentabilidad_esperada || form.rentabilidad_esperada === '' || parseInt(form.rentabilidad_esperada) === 0) {
            toast.warn("Falta ingresar rentabilidad optima")
            return false
        }

        await Settings.saveNewRuleProfit(form)
        await getRulesList()

        setForm(initialState)

    }

    return (
        <form onSubmit={handleSubmitNewUser} className='mt-3'>
            <Grid container spacing='20' columnSpacing='16' alignItems='center' direction='row'>

                <Grid item>
                    <div className='p-info'>
                        <Selects
                            label='Tipo'
                            name='id_tipo_regla'
                            value={form.id_tipo_regla}
                            onChange={handleChange}
                            data={typeList}
                            style={{ width: '250px' }}
                        />
                    </div>
                </Grid>

                {form.id_tipo_regla === 2 &&
                    <Grid item>
                        <div className='p-info'>
                            <Selects
                                label='Unidad de negocio'
                                name='id_unidad_negocio'
                                value={form.id_unidad_negocio}
                                onChange={handleChange}
                                style={{ width: '250px' }}
                                data={unitList}
                            />
                        </div>
                    </Grid>
                }

                {form.id_tipo_regla > 0 &&
                    <Grid item>
                        <div className='p-input-email'>
                            <InputsNumbers
                                label='% rentabilidad optima (*)'
                                name='rentabilidad_esperada'
                                value={form.rentabilidad_esperada || ''}
                                placeholder='Ingrese rentabilidad'
                                onChange={handleChange}
                                simbolo='%'
                            />
                        </div>
                    </Grid>
                }

                <Grid item>
                    <div>
                        <Buttons
                            label='Agregar'
                            type='submit'
                        />
                    </div>
                </Grid>

            </Grid>
        </form>
    )
}